module.exports = __webpack_public_path__ + "static/4BHK-02-Dining-3ccde5c90df9c622babbfb01b8e3fc7f.jpg";